var React = require('react');

function MinusInCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"17.5","cy":"17.5","r":"16.5","stroke":"#D4D4D4","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M23 17.499H12","stroke":"#161616","strokeWidth":"2","key":1})]);
}

MinusInCircle.defaultProps = {"width":"35","height":"35","viewBox":"0 0 35 35","fill":"none"};

module.exports = MinusInCircle;

MinusInCircle.default = MinusInCircle;
